import '../vendors/jquery.easydropdown';
import Cookies from 'js-cookie';

class Funds {

    constructor() {
        this.umbrellaFunds = document.querySelectorAll('[funds-filterable-main]');
        this.subFunds = document.querySelectorAll('[funds-filterable]');
        this.fundsContainer = document.getElementById('funds-container');
        this.content = document.getElementById('fund-content');
        this.contentWrap = document.getElementById('fund-content-wrap');
        this.spinner = document.getElementById('fund-spinner');
        this.closeMobileContent = document.getElementById('funds-content-close');
        this.resetCookieHomeLink = document.querySelectorAll('[funs-cookie-reset]');

        this.init();
    }

    init() {
        this.umbrellaClickWatch();
        this.subClickWatch();
        this.changeProfileClickWatch();
        this.submitStrategy();
        this.runShareEasyDropDown();
        this.runLanguageEasyDropDown();

        this.passwordFormSubmitWatch();
        if( window.outerWidth >= 768 ){
            this.checkInitiallyActiveUmbrellaFunds();
        }
        if (window.innerWidth < 768){
            this.mobileCategories();
        }

        if (window.innerWidth < 769) {
            this.closeMobileContentClickWatch();
        }
    }

    /**
     * Check and adjust container height after DOM is loaded if there any active Umbrella fund
     * otherwise output all subFunds ( on initially page load )
     */
    checkInitiallyActiveUmbrellaFunds() {
        document.addEventListener('DOMContentLoaded', ()=>{
            let activeUmbrellaFund = document.querySelector('[funds-filterable-main].active');
            
            // adjust height if there is active Umbrella Fund 
            if(activeUmbrellaFund){
                let activeSubFunds = activeUmbrellaFund.parentNode.querySelector('ul');
                if(activeSubFunds) this.adjustContainerHeight(activeSubFunds);
            }

            // output all subfunds on initial page load when there is no fund has been selected
            else{
                let allSubFunds = document.querySelectorAll('.funds-sidenav-sub > li');
                if(!allSubFunds.length) return;
                    
                let pseudoSubFunds = document.createElement('ul');
            
                pseudoSubFunds.classList.add('funds__body__nav__pseudo');

                Array.from(allSubFunds).forEach(el => {
                    let clonedElement = el.cloneNode(true);
                    let clonedElementLink = clonedElement.querySelector('a');
                    
                    if( clonedElementLink ){
                        clonedElementLink.addEventListener('click', evt =>{
                            evt.preventDefault();
    
                            this.clearSubActiveClass();
    
                            if (window.innerWidth < 769) {
                                this.contentWrap.classList.add('is-opened');
                                document.body.style.overflowY = 'hidden';
                            }
                            
                            let realSubFund = document.querySelector(`.funds-sidenav-sub a[href="${evt.currentTarget.href}"]`)
                            
                            pseudoSubFunds.remove();
                            realSubFund.classList.add('active');
                            try{
                                realSubFund.closest('.funds__body__nav__item').querySelector('a[funds-link-main]').classList.add('active');
                            } catch(err) {
                                console.warn('there is no element ".funds__body__nav__item" or "a[funds-link-main]"')
                            }
                            
    
                            //this.updateContent();
                            if (typeof history.pushState !== "undefined") {
                                this.updateContent(realSubFund.getAttribute('href') + '?cb=' + (new Date().getTime()));
                                history.pushState({}, null, realSubFund.getAttribute('href'));
                            }else{
                                window.location = realSubFund.getAttribute('href');
                            }
                            
                            let subFunds = realSubFund.closest('ul');
                            if(subFunds) this.adjustContainerHeight(subFunds);
                        })
                    }
                    
                    pseudoSubFunds.appendChild( clonedElement );
                });
                
                document.querySelector('.funds__body__nav').appendChild(pseudoSubFunds);
                this.adjustContainerHeight(pseudoSubFunds);
                
            }

        })
    }

    /**
     * Umbrella Funds onClick Listener
     */
    umbrellaClickWatch() {
        if (!this.umbrellaFunds.length) return;

        Array.from(this.umbrellaFunds).forEach((elem, index) => {
            elem.addEventListener('click', (evt) => {
                evt.preventDefault();
                evt.stopImmediatePropagation();
            
                this.clearUmbrellaActiveClass();
                this.clearSubActiveClass();
                
                let pseudoSubFunds = document.querySelector('.funds__body__nav__pseudo');
                if(pseudoSubFunds) pseudoSubFunds.remove();

                evt.currentTarget.classList.add('active');

                let subFunds = evt.currentTarget.parentNode.querySelector('ul');

                if (window.innerWidth < 768) {
                    this.contentWrap.classList.add('is-opened');
                    document.body.style.overflowY = 'hidden';
                }

                //this.updateContent();
                if (typeof history.pushState !== "undefined") {
                    this.updateContent(elem.getAttribute('href') + '?cb=' + (new Date().getTime()));
                    history.pushState({}, null, elem.getAttribute('href'));
                }else{
                    window.location = elem.getAttribute('href');
                }

                this.adjustContainerHeight(subFunds);
            });
        });
    }

    /**
     * Sub-Funds onClick Listener
     */
    subClickWatch() {
        if (!this.subFunds) return;

        Array.from(this.subFunds).forEach((elem, index) => {
            elem.addEventListener('click', (evt) => {
                evt.preventDefault();

                this.clearSubActiveClass();

                if (window.innerWidth < 769) {
                    this.contentWrap.classList.add('is-opened');
                    document.body.style.overflowY = 'hidden';
                }

                //this.updateContent();
                if (typeof history.pushState !== "undefined") {
                    this.updateContent(elem.getAttribute('href') + '?cb=' + (new Date().getTime()));
                    history.pushState({}, null, elem.getAttribute('href'));
                }else{
                    window.location = elem.getAttribute('href');
                }

                evt.currentTarget.classList.add('active');
            });
        });
    }
    

    /**
     * Remove 'active' css class for each Umbrella Funds Item
     */
    clearUmbrellaActiveClass() {

        if (this.umbrellaFunds) {
            Array.from(this.umbrellaFunds).forEach((elem, index) => {
                elem.classList.remove('active');
            });
        }
    }

    /**
     * Remove 'active' css class for each Sub-Funds Item
     */
    clearSubActiveClass() {

        if (this.subFunds) {
            Array.from(this.subFunds).forEach((elem, index) => {
                elem.classList.remove('active');
            });
        }
    }

    /**
     * Adjust Funds container min height respectevely to Sub-Funds container height
     */
    adjustContainerHeight(subFunds) {
        if (!subFunds || !this.fundsContainer) return;
        let height = subFunds.offsetHeight;
        this.fundsContainer.style.minHeight = height + 'px';

    }

    /**
     * Update content part with AJAX request response
     */
    updateContent( url ) {
        this.hideContent();

        /* timeout might been removed after backend integration */
        setTimeout(() => {
            //let responsePromice = this.getData('./data/funds-ajax-data.html');
            let responsePromice = this.getData(url);

            if (!responsePromice) return;

            responsePromice
                .then(text => {
                    // if (text == 'error') {
                    //     var error = new Error('Response error!')
                    //     throw error;
                    //     this.showContent('');
                    //     return;
                    // }
                    if (text == null) {
					    return window.location = document.getElementsByClassName("nav__logo").href;
					}
                    this.showContent(text)

                })
                .catch(error => {
                    console.warn(error.message);
                });
        }, 600)


    }

    /**
     * Get Fund data(content)
     */
    getData(url) {
        // return fetch(url, {
        //     method: 'get'
        // })
        // .then(response => {
        //     if (response.status == '200') {
        //         return response.text().then(text => text);
        //     } else {
        //         return Promise.reject(Error('error'))
        //     }
        // })
        // .catch(error => Promise.reject(Error('error')));

        return $.ajax({
            url: url,
            context: document.body
        }).then(function(data){
            var content = $(data).find('#fund-content');
            return content.html();
        });

    }

    /**
     * Hide content part and show spinner(preloader)
     */
    hideContent() {
        if (this.content) {
            this.content.classList.add('is-hidden');
        }

        if (this.spinner) {
            this.spinner.classList.add('is-opened');
        }
    }

    /**
     * Show content part and hide spinner(preloader)
     */
    showContent(text) {
        if (this.content) {
            this.content.innerHTML = text;
            this.runShareEasyDropDown();
            this.runLanguageEasyDropDown();

            this.content.classList.remove('is-hidden');
        }
        if (this.spinner) {
            this.spinner.classList.remove('is-opened');
        }
    }

    /**
     * Language select
     */
    langSelect(){
        let langSelect = 'select[name="language"]';
        

        $.get('/funds/document-languages/' + arguments[0], function(options) {
            var $selectToFill, i, len, option, results1;
            $selectToFill = arguments[1].parents('[fund-form-download]').find(langSelect);

            console.log('$selectToFill', $selectToFill);
            $selectToFill.find('option:not([value=""])').remove();
            results1 = [];
            for (i = 0, len = options.length; i < len; i++) {
                option = options[i];
                results1.push($selectToFill.append($('<option value="' + option.id + '">' + option.name + '</option>')));
            }
            return results1;
        });
    }

    /**
     * Run Language EasyDropDown
     */
    runLanguageEasyDropDown(){
        if ($('.lang-select').length) {
            $('.lang-select').easyDropDown({
                cutOff: 6,
                onChange: function(selected){
                    console.log(selected);
                   
                }
            });
        }
    }

    /**
     * Run Share Class EasyDropDown
     */
    runShareEasyDropDown(){
        var _thisShowContent = this;
        if ($('.share-class').length) {
            $('.share-class').easyDropDown({
                cutOff: 6,
                onChange: function(selected){
                    if(selected.value != ''){
                        if (typeof history.pushState !== "undefined") {
                            _thisShowContent.updateContent(selected.value + '?cb=' + new Date().getTime());
                            history.pushState({}, null, selected.value);
                        } else {
                            window.location = selected.value;
                        }
                    }
                }
            });
        }
    }

    /**
     * Fire Strategy form onSubmit when strategy changed
     */
    submitStrategy(){
        let strategies = document.querySelectorAll('[name="strategy_id"]');
    
        if( !strategies && !strategies.length) return;

        Array.from(strategies).forEach( el => {
            el.addEventListener('change', evt => {
                evt.stopImmediatePropagation();
                let form = evt.currentTarget.closest('form');
                form.submit();
            })
        } );
        
    }

    /** 
     * Mobile categories dropdown ( Strategies )
     */
    mobileCategories() {

        $('#funds-cats-mobile').easyDropDown({
            onChange: function (selected) {

                // trigger hidden category radio button
                let radioBtn = document.querySelector('[name="strategy_id"][value="' + selected.value + '"]');
                if (radioBtn) radioBtn.checked = true;
                let form = radioBtn.closest('form').submit();
                if(form) form.submit();
            }
        });
    }

    /**
     * Watch click Content Close button for mobile
     */
    closeMobileContentClickWatch() {

        if (!this.closeMobileContent && !this.content) return;

        this.closeMobileContent.addEventListener('click', (evt) => {
            this.contentWrap.classList.remove('is-opened');
            document.body.style.overflowY = 'visible';
        });
    }

    /**
     * Password checking
     */
    passwordFormSubmitWatch() {
        var _thisPassword = this;
        if( !this.content ) return;
        this.content.addEventListener('submit', (evt) => {
            
            evt.stopImmediatePropagation();
            if (evt.target.hasAttribute('funds-password-test')) {
                evt.preventDefault();
                let passwordField = evt.target.querySelector('input[name="password"]');
                let label = document.querySelector('[password-label]');
                let passwordForm = document.querySelector('[funds-password-test]');

                if( passwordField && passwordField.value === '' ){
                    label.classList.add('is-empty');
                    passwordForm.classList.add('is-incorect');
                }
                else{ 
                    label.classList.remove('is-empty');
                    
                    let form = $('[funds-password-test]').serializeArray();
                    return $.post(passwordForm.getAttribute('action'), form, function(resp) {
                        if (resp.status) {
                            label.classList.remove('incorect-label');
                            passwordForm.classList.remove('is-incorect')
                            _thisPassword.updateContent(window.location.href);
                        } else {
                            label.classList.add('incorect-label');
                            passwordForm.classList.add('is-incorect');
                        }
                    });
                } 
            }
        })
    };


    /**
     * Change profile link onClick
     */
    changeProfileClickWatch() {
        if (this.resetCookieHomeLink.length) { 
            Array.from(this.resetCookieHomeLink).forEach(el=>{
                el.addEventListener('click', (evt) => {            
                    Cookies.remove('funds_auth_investor');
                    Cookies.remove('funds_auth_country');
                })
            });
            
        }
    }
}

export default Funds;


// WEBPACK FOOTER //
// ./scripts/modules/funds.js